export const settingsStateTypes = {
  SET_CURRENT_TIMEZONE: "SET_CURRENT_TIMEZONE",
};
